import { render, staticRenderFns } from "./AddDancer.vue?vue&type=template&id=f138028a&scoped=true&"
import script from "./AddDancer.vue?vue&type=script&lang=js&"
export * from "./AddDancer.vue?vue&type=script&lang=js&"
import style0 from "./AddDancer.vue?vue&type=style&index=0&id=f138028a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f138028a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f138028a')) {
      api.createRecord('f138028a', component.options)
    } else {
      api.reload('f138028a', component.options)
    }
    module.hot.accept("./AddDancer.vue?vue&type=template&id=f138028a&scoped=true&", function () {
      api.rerender('f138028a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dancers/AddDancer.vue"
export default component.exports